// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

// NewUser page components
import FormField from "modules/inspections/components/FormField";
import { useState } from "react";
import { Box, Card, Icon, Switch } from "@mui/material";
import { SyncLoader } from 'react-spinners';
import SoftSelect from "components/SoftComponents/SoftSelect";
import SoftInput from "components/SoftComponents/SoftInput";
import SoftButton from "components/SoftComponents/SoftButton";
import Divider from "@material-ui/core/Divider";

import badgeDict from "modules/inspections/components/badgeDict.json";
import SprayCan from "assets/images/spray_can_white.png";
import BrokenDevice from "assets/images/broken_device_white.png";
import { PhotoProvider, PhotoView } from "react-photo-view";
import theme from "assets/theme";

function Review({ formData }) {
    const {
        values, touched, errors, formField, isSubmitting,
        functions: { setDeviceOptions, setFieldValue, handleChange, handleBack, handleCancel },
        custom: { activeStep, isLastStep, user }
    } = formData;

    function getArrValues(device_type, label, create_object = false) {
        var ret = [];
        var label_values = Object.keys(values).filter((row) => row.includes(`${device_type}-${label}`));

        for (var el of label_values) {
            var element_arr = el.split('-');
            var type = element_arr[(element_arr.length - 1)];

            if (values[`${device_type}-${label}-${type}`] == true) {
                if (!create_object) {
                    ret.push(values[`${device_type}-${label}-${type}`]);
                } else {
                    ret.push([type, values[`${device_type}-${label}-${type}`]]);
                }
            }
        }

        console.log(ret);

        return ret;
    }

    const reviewItems = (deviceIndex) => {
        var form_type = values["devicePrimary-actions-removed"] ? "decommission" : "repair";
        var label = deviceIndex == 0 ? "devicePrimary" : "deviceSecondary";

        if (values["deviceSecondary-uuid"]?.trim().length > 0) {
            form_type = "replacement";
        }

        return (
            <>
                {(deviceIndex == 1) && (
                    <Grid item xxs={12} sx={{
                        display: 'block',
                        [theme.breakpoints.up("lg")]: {
                            display: 'none'
                        }
                    }} >
                        <SoftBox py={2}>
                            <Divider orientation="horizontal" />
                        </SoftBox>
                    </Grid>
                )}
                <Grid item xxs={12} lg={values["deviceSecondary-uuid"]?.trim().length > 0 ? 6 : 12}>
                    <SoftBox p={{xxs: 0, lg: 1}}>
                        {values["deviceSecondary-uuid"]?.trim().length > 0 && (
                            <SoftBox textAlign="center" pb={2}>
                                <SoftTypography variant="h5">{deviceIndex == 0 ? "Original Inspection" : "Rectification"}</SoftTypography>
                            </SoftBox>
                        )}
                        {(form_type == "decommission" && deviceIndex == 1) ? (
                            <SoftBox py={2} sx={{ backgroundColor: "#f8f8f8", borderRadius: "10px" }} >
                                <SoftTypography variant="h6" textAlign="center">Device has been decommissioned.</SoftTypography>
                            </SoftBox>
                        ) : (
                            <SoftBox py={2} sx={{ backgroundColor: "#f8f8f8", borderRadius: "10px" }}>
                                <SoftBox ml={{xxs: 1, sm: 5}}>
                                    <SoftTypography variant="h6">{form_type == "replacement" && deviceIndex == 1 ? "Replacement Device" : "Device"}</SoftTypography>
                                    <SoftBox pt={0.5} pl={1} display="flex" flexDirection="column">
                                        <SoftTypography variant="body2" color="regular">
                                            {values.organisation_id == "clearways" ? "eMinor" : "Name"}: <b>{values[`${label}-info`].label}</b>
                                        </SoftTypography>
                                        <SoftTypography variant="body2" fontWeight="regular">Stop ID: <b>{values[`${label}-stop_id`]}</b></SoftTypography>
                                        <SoftTypography variant="body2" fontWeight="regular">Serial No: <b>{values[`${label}-serial_no`]}</b></SoftTypography>
                                    </SoftBox>
                                </SoftBox>
                            </SoftBox>
                        )}
                        <SoftBox py={2}>
                            <SoftBox ml={{xxs: 1, sm: 5}}>
                                <SoftTypography variant="h6">Maintenance/Repairs Carried Out?</SoftTypography>
                                <SoftBox pt={1} pl={1}>
                                    {(getArrValues(label, "conditions").length > 0 || getArrValues(label, "actions").length > 0) ? (
                                        <Grid container spacing={1}>
                                            {getArrValues(label, "conditions").length > 0 && (
                                                <Grid item xxs={12} md={6}>
                                                    <SoftBox>
                                                        <SoftTypography variant="caption" fontWeight="bold">
                                                            Device Conditions
                                                        </SoftTypography>
                                                        {getArrValues(label, "conditions", true).map(([key, value], conIndex) => (
                                                            <SoftBox key={conIndex} pt={0.25}>
                                                                <SoftBox pl={0.5} pb={0.25} display="flex" flexDirection="row" alignItems="center">
                                                                    {badgeDict[key].icon == "SprayCan" && (
                                                                        <SoftBox component="img" src={SprayCan} variant="gradient" bgColor={badgeDict[key].color} sx={{ borderRadius: "4px", width: "24px", height: "24px" }} />
                                                                    )}
                                                                    {badgeDict[key].icon == "BrokenDevice" && (
                                                                        <SoftBox component="img" src={BrokenDevice} variant="gradient" bgColor={badgeDict[key].color} sx={{ borderRadius: "4px", width: "24px", height: "24px" }} />
                                                                    )}
                                                                    {(badgeDict[key].icon != "BrokenDevice" && badgeDict[key].icon != "SprayCan") && (
                                                                        <SoftBox variant="gradient" bgColor={badgeDict[key].color} sx={{ borderRadius: "4px", width: "24px", height: "24px" }}>
                                                                            <Icon fontSize="22px !important" sx={{ color: "#fff", fontSize: "22px", display: "flex", alignItems: "center", justifyContent: "center", width: "24px !important", height: "24px !important" }}>{badgeDict[key].icon}</Icon>
                                                                        </SoftBox>
                                                                    )}
                                                                    <SoftTypography pl={1} variant="subtitle2" textTransform="capitalize">{key.replace("_", " ")}</SoftTypography>
                                                                </SoftBox>
                                                                {key == "other" && (
                                                                    <SoftBox pl={5}>
                                                                        <SoftTypography variant="caption">{value}</SoftTypography>
                                                                    </SoftBox>
                                                                )}
                                                            </SoftBox>
                                                        ))}
                                                    </SoftBox>
                                                </Grid>
                                            )}
                                            {getArrValues(label, "actions").length > 0 && (
                                                <Grid item xxs={12} md={6}>
                                                    <SoftBox>
                                                        <SoftTypography variant="caption" fontWeight="bold">
                                                            Technician Actions
                                                        </SoftTypography>
                                                        {getArrValues(label, "actions", true).map(([key, value], acIndex) => (
                                                            <SoftBox key={acIndex} pt={0.25}>
                                                                <SoftBox pl={0.5} pb={0.25} display="flex" flexDirection="row" alignItems="center">
                                                                    <SoftBox variant="gradient" bgColor={'success'} sx={{ borderRadius: "4px", width: "24px", height: "24px" }}>
                                                                        <Icon fontSize="22px !important" sx={{ color: "#fff", fontSize: "22px", display: "flex", alignItems: "center", justifyContent: "center", width: "24px !important", height: "24px !important" }}>check</Icon>
                                                                    </SoftBox>
                                                                    <SoftTypography pl={1} variant="subtitle2" textTransform="capitalize">{key.replace("_", " ")}</SoftTypography>
                                                                </SoftBox>
                                                            </SoftBox>
                                                        ))}
                                                    </SoftBox>
                                                </Grid>
                                            )}
                                        </Grid>
                                    ) : (
                                        <SoftTypography variant="body4">No</SoftTypography>
                                    )}
                                </SoftBox>
                            </SoftBox>
                        </SoftBox>
                        <SoftBox py={2} sx={{ backgroundColor: "#f8f8f8", borderRadius: "10px" }}>
                            <SoftBox ml={{xxs: 1, sm: 5}}>
                                <SoftTypography variant="h6">Site Images</SoftTypography>
                                <SoftBox pt={1} pl={1} display="flex" flexDirection="column">
                                    {values[`${label}-images`].length > 0 ? (
                                        <PhotoProvider id={label}>
                                            <SoftBox pt={1}>
                                                <Grid container spacing={1}>
                                                    {values[`${label}-images`].map((img, imgIndex) => (
                                                        <Grid item key={imgIndex} xxs={4} lg={3} x3l={2}>
                                                            <PhotoView src={img.previewUrl}>
                                                                <SoftBox
                                                                    component="img"
                                                                    src={img.previewUrl}
                                                                    width="100%"
                                                                    height="200px"
                                                                    sx={{
                                                                        objectFit: "cover",
                                                                        borderRadius: "5px",
                                                                        cursor: "pointer",
                                                                        transition: "box-shadow 0.3s ease-in-out",
                                                                        "&:hover": {
                                                                            boxShadow: "0 0 15px 2px rgba(0, 0, 0, 0.3)",
                                                                        }
                                                                    }}
                                                                />
                                                            </PhotoView>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </SoftBox>
                                        </PhotoProvider>
                                    ) : (
                                        <SoftTypography variant="body4">No images added.</SoftTypography>
                                    )}
                                </SoftBox>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                </Grid>
            </>
        );
    }

    return (
        <SoftBox>
            <SoftBox>
                <SoftBox mb={3} display="flex" flexDirection="column" alignItems="center">
                    <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
                        Inspection Review
                    </SoftTypography>
                    <SoftTypography pt={1} variant="mobileBody1" textAlign="center">
                        Please review and check that all inspection information is correct.
                    </SoftTypography>
                </SoftBox>
                <Divider />
                <SoftBox my={2}>
                    <SoftBox ml={{xxs: 1, sm: 5}}>
                        <SoftTypography variant="h6">Overview</SoftTypography>
                        <SoftBox pt={1} pl={1} display="flex" flexDirection="column">
                            <SoftTypography variant="caption" fontWeight="bold">
                                Inspection Title
                            </SoftTypography>
                            <SoftTypography variant="body4">{values['title'] == "" ? values['inspection_type'] : values['title']}</SoftTypography>
                        </SoftBox>
                        <SoftBox pt={2} pl={1} display="flex" flexDirection="column">
                            <SoftTypography variant="caption" fontWeight="bold">
                                Additional Information
                            </SoftTypography>
                            <SoftTypography variant="body4">{values['description'] == "" ? 'No notes added.' : values['description']}</SoftTypography>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
                <Divider />
                <Grid container mt={2}>
                    {reviewItems(0)}
                    {values?.['deviceSecondary-uuid']?.trim().length > 0 && (
                        <>
                            <Box sx={{
                                width: 0, display: "flex", justifyContent: "center", opacity: 0,
                                [theme.breakpoints.up("lg")]: {
                                    opacity: 1
                                }
                            }}>
                                <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
                            </Box>
                            {reviewItems(1)}
                        </>
                    )}
                </Grid>
            </SoftBox>
            <SoftBox mt={5} width="100%" display="flex" justifyContent="space-between">
                <SoftButton variant="gradient" color={activeStep === 0 ? "error" : "light"} onClick={activeStep === 0 ? handleCancel : handleBack}>
                    {activeStep === 0 ? "cancel" : "back"}
                </SoftButton>
                <SoftButton
                    disabled={isSubmitting}
                    type="submit"
                    variant="gradient"
                    color="dark"
                >
                    {isLastStep ? "submit" : "next"}
                </SoftButton>
            </SoftBox>
        </SoftBox >
    );
}

// typechecking props for Review
Review.propTypes = {
    formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default Review;